// src/components/ThemeToggle.js
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import verifiedPropertyLogo from '../../images/verified-properties-logo.svg';
import bell from '../../images/bell.svg';
import profileImg from '../../images/profile_img.svg';
import secure from '../../images/secure.svg';
import passwordIcon from '../../images/password-icon.svg';
import user from '../../images/users.svg';
import arrow from '../../images/arrow.svg';
import logOut from '../../images/log-out.svg';
import ebank from '../../images/ebank.svg';
import { API_BASE_URL } from "../../constants/apiConstants";
import { ASSETS_URL } from "../../constants/apiConstants";
import { Bearer_Token } from "../../constants/apiConstants";
import axios from "axios";
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel } from 'swiper/modules';
import Modal from 'react-modal';
import Stories from 'stories-react';
import 'stories-react/dist/index.css';
import { useLocation } from 'react-router-dom';
import { ToastContainer, toast, Slide } from 'react-toastify';
import { ReactComponent as Loader } from '../../images/loader.svg'
import comment from "../../images/comment.svg";
import vchat from "../../images/v-chat.svg";
import noImage from "../../images/no-image.svg";
import arrowdown from "../../images/arrow-down.svg";
import { replaceUnicodeWithEmoji } from "../../helper/helpers"
import enter from "../../images/enter.jpeg";
import dottedvr from "../../images/dotted_vr.svg";
import longarrow from "../../images/long-arrow.svg";
import dollor from "../../images/dollor.svg";
import voice from "../../images/voice.svg";
import camera from "../../images/camera.svg";

const customStylesLogin = {
    content: {
      top: '0px',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '0',
      transform: 'translate(-50%, 0%)',
      background: 'none',
      border: 'none',
      paddingTop:'100px',
      zIndex:'999'

    },
    overlay: {
       top: 0
    },
};

const customStyles = {
    content: {
        top: '0px',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, 0%)',
        background: 'none',
        border: 'none',
        padding:'0'
    },
    overlay: {
        top: 299
    },
};

const customStylesNotification = {
    content: {
      top: '0px',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '0',
      transform: 'translate(50%, 0%)',
      background: 'none',
      border: 'none',
      paddingTop:'30px',
      zIndex:'999'
    },
    overlay: {
       top: 0
      },
};

const customStylesChat = {
    content: {
      top: '0px',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '0',
      transform: 'translate(50%, 0%)',
      background: 'none',
      border: 'none',
      paddingTop:'30px',
      zIndex:'999'
    },
    overlay: {
       top: 0
      },
};

const Header = () => {
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();
    const { pathname } = location;
    const [story,setStory] = useState([]); 
    const [userStories,setUserStories] = useState([]); 
    const [userName,setUserName] = useState(''); 
    const [profilePicture,setProfilePicture] = useState(''); 
    const [isActive, setIsActive] = useState(1)
    const[loading, setLoading] =useState(false);
    const token = localStorage.getItem("ACCESS_TOKEN");
    const [activeIndex, setActiveIndex] = useState(null);
    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [logInmodalIsOpen, setLogInModalIsOpen] = React.useState(false);
    const [notificationModalIsOpen, setNotificationModalIsOpen] = React.useState(false);
    const [chatModalIsOpen, setChatModalIsOpen] = React.useState(false);
    const [isLogin,setIsLogin] = useState(1);
    const [chatHistory,setChatHistory] = useState([]);
    const [chatDetails,setChatDetails] = useState([]);
    const [loggedInUserId,setLoggedInUserId] = useState(null);
    const [chatUserName,setChatUserName] = useState(null);
    const [chatUserId,setChatUserId] = useState(null);
    const [chatUserProfilePicture,setChatUserProfilePicture] = useState(null);
    const [isChatVisible,setIsChatVisible] = useState(false);
    const [inputText,setInputText] = useState("");
    const boxRef = useRef(null);

    const stories = ()  => {
        axios.get(API_BASE_URL+'get/stories',{
            headers: {
                Authorization: `Bearer ${Bearer_Token}`,
            }
        })
        .then((response) => {
            setStory(response.data.data)
        })
        .catch((error) => {
            toast.error(error, {
                position: "top-right",
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
            });
        })
    }
    
    let subtitle;
    function openModal(userId,index,image) {
        setActiveIndex(index);
        axios.get(API_BASE_URL+'get/user/stories/'+userId,{
            headers: {
                Authorization: `Bearer ${Bearer_Token}`,
            }
        })
        .then((response) => {
            setUserStories(response.data.data);
            document.body.style.overflow = 'hidden';
            setLogInModalIsOpen(false);
            setIsOpen(true);
            setUserName(response.data.user_name);
            setProfilePicture(ASSETS_URL+"agent/profile/"+image);
        })
        .catch((error) => {
            toast.error(error, {
                position: "top-right",
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
            });
        })
    }

    function afterOpenModal() {
        subtitle.style.color = '#f00';
    }

    function closeModal() {
        document.body.style.overflow = 'unset';
        setActiveIndex(null);
        setIsOpen(false);
    }

    function openLogInModal() {
        document.body.style.overflow = 'hidden';
        setIsOpen(false);
        setLogInModalIsOpen(true);
    }

    function openChatModal() {
        document.body.style.overflow = 'hidden';
        setIsChatVisible(false);
        setIsOpen(false);
        setLogInModalIsOpen(false);
        setNotificationModalIsOpen(false);
        setChatModalIsOpen(true);
    }

    function openNotificationModal() {
        document.body.style.overflow = 'hidden';
        setIsOpen(false);
        setNotificationModalIsOpen(true);
    }

    function closeLogInModal() {
        document.body.style.overflow = 'unset';
        setLogInModalIsOpen(false);
    }

    function closeNotificationModal() {
        document.body.style.overflow = 'unset';
        setNotificationModalIsOpen(false);
    }

    function closeChatModal() {
        console.log(1213655654);

        document.body.style.overflow = 'unset';
        setChatModalIsOpen(false);
    }
    
    const [state, setState] = useState({
        email: "",
        password: "",
        successMessage: null
    })

    const handleChange = (e) => {
        const {name, value} = e.target
        setState(prevState => ({
            ...prevState,
            [name] : value
            })
        )
    }

    const handleSubmitClick = (e) => {
        e.preventDefault();
        if(state.email === "" || state.password === ""){
            toast.error("Please provide a valid input", {position: "top-center",autoClose: 5000,hideProgressBar: false,closeOnClick: false,pauseOnHover: true,draggable: true,theme: "dark",transition: Slide});
            return false;
        }
        if(state.email !== "" && state.password !== ""){
          const payload = {
            "email":state.email,
            "password":state.password,
          }
          setIsLoading(true);
          axios.post(API_BASE_URL+'user/login',payload)
            .then(function (response){ 
                if(response.data.apistatus === true){
                    toast.success(response.data.message, {position: "top-center",autoClose: 5000,hideProgressBar: false,closeOnClick: false,pauseOnHover: true,draggable: true,theme: "dark",transition: Slide});
                    localStorage.setItem("ACCESS_TOKEN", response.data.data.token);
                    setIsLoading(false);
                    window.location.href = '/';
                }else if(response.data.apistatus === false){
                    setIsLoading(false);
                    toast.error(response.data.message, {position: "top-center",autoClose: 5000,hideProgressBar: false,closeOnClick: false,pauseOnHover: true,draggable: true,theme: "dark",transition: Slide});
                }
            })
            .catch(function (error){
                setIsLoading(false);
                toast.error(error, {
                    position: "top-right",
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                });
            })
        }
    };

    const logout = (e) => {
        const payload = {
        token: localStorage.getItem('ACCESS_TOKEN')
        }
        axios.post(API_BASE_URL+'logout',payload,{
            headers: {
                Authorization: `Bearer ${localStorage.getItem('ACCESS_TOKEN')}`,
            }
        })
        .then(function (response){
            if(response.data.apistatus === true){
                toast({ title: response.data.message,status: 'success',isClosable: true,position: 'top'})
                localStorage.setItem("ACCESS_TOKEN", '');
                window.location.href = '/';
            }else if(response.data.apistatus === false){
                toast({ title: response.data.message,status: 'error',isClosable: true,position: 'top'})
            }
        })
        .catch(function (error){
            toast({ title: error,status: 'error',isClosable: true,position: 'top'})
        })
    }

    const [notifications,setNotifications] = useState([]);
    const getNotifications = (e) => {
        axios.get(API_BASE_URL+'notification/list',{
            headers: {
                Authorization: `Bearer ${Bearer_Token}`,
            }
        })
        .then(function (response){
            setNotifications(response.data.data);
        })
        .catch((error) => {
            toast.error(error, {
                position: "top-right",
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
            });
        })
    }

    const firstLogin = () => {
        toast.error("Please login to this event.", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
          transition: Slide,
        });
    };

    const getChatHistory = (e) => {
        axios.get(API_BASE_URL+'chat/history',{
            headers: {
                Authorization: `Bearer ${Bearer_Token}`,
            }
        })
        .then(function (response){
            setChatHistory(response.data.data);
        })
        .catch((error) => {
          toast.error(error, {
              position: "top-right",
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
          });
        })
    }

    const getChatDetails = (id,userName,profilePicture) => {
        setChatUserName(userName);
        setChatUserId(id);
        if(profilePicture){
            setChatUserProfilePicture(ASSETS_URL+"agent/profile/"+profilePicture);
        }else{
            setChatUserProfilePicture(null);
        }
        const payload = {
          "user_id":id
        }
        axios.post(API_BASE_URL+'chat/details',payload,{
            headers: {
                Authorization: `Bearer ${Bearer_Token}`,
            }
        })
        .then(function (response){
            setChatDetails(response.data.data.chatMessages);
            setLoggedInUserId(response.data.data.uId);
            setIsChatVisible(true);
            if (boxRef.current) {
                boxRef.current.scrollTo({
                    top: boxRef.current.scrollHeight,
                    behavior: 'smooth',
                });
            }
        })
        .catch((error) => {
          toast.error(error, {
              position: "top-right",
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
          });
        })
    }

    const handlerChatFuntion= (uId) => {
      if(inputText.length > 0){
        const payload = {
          "message":inputText,
          "user_id":uId,
        }
        axios.post(API_BASE_URL+'chat/send-message',payload,{
            headers: {
                Authorization: `Bearer ${Bearer_Token}`,
            }
        })
        .then(function (response){
            getChatHistory()
            setChatDetails((chatDetails) => [...chatDetails, ...response.data.data]);
            setInputText('');
        })
        .catch((error) => {
          toast.error(error, {
              position: "top-right",
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
          });
        })
      }
    }

    const backToChatButton = () => {
        setIsChatVisible(false);
    }
    

    useEffect(()=> {
        stories()
        getNotifications()
        getChatHistory()
        axios.interceptors.request.use(function (config) {
            setLoading(true);
            return config;
        }, function (error) {
        // Do something with request error
        return Promise.reject(error);
        });
        // Add a response interceptor
        axios.interceptors.response.use(function (response) {
            setLoading(false);
            return response;
        }, function (error) {
            // Any status codes that falls outside the range of 2xx cause this function to trigger
            // Do something with response error
            return Promise.reject(error);
        });
    },[]);

    return (
        <>
            
            <ToastContainer />

            <Modal
                isOpen={modalIsOpen}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                {/* <h3 ref={(_subtitle) => (subtitle = _subtitle)}> <img src={storyImg} alt="story_title" /></h3> */}
                <h3 ref={(_subtitle) => (subtitle = _subtitle)}> </h3>
                <button className="button_story_pop" onClick={closeModal}><img src={arrow} alt="arrow" /></button>
                <div>
                <Link to="/broker/details" target="_blank"><span className="user_profile_picture"><img class="pro_pic_img" src={profilePicture} alt="profile picture" /></span></Link>
                <span className="username_story">{userName}</span>
                <Stories width="400px" height="600px" stories={userStories}/>
                </div>
            
            </Modal>

            <Modal
                isOpen={logInmodalIsOpen}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeLogInModal}
                style={customStylesLogin}
                contentLabel="Example Modal"
                bodyOpenClassName="modal-open2"
            >
                <h3 ref={(_subtitle) => (subtitle = _subtitle)}></h3>
                
                <div class="modal_box2">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                            <div class="modal_boxnew">
                                <button className="button_story_pop" onClick={closeLogInModal}><img src={arrow} alt="arrow" /></button>
                                <ul class="nav nav-pills mb-3 justify-content-around" id="pills-tab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <button class={isLogin === 1 ? 'nav-link active' : 'nav-link'} id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true" onClick={() => setIsLogin(1)}>LOG IN</button>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <button class={isLogin === 2 ? 'nav-link active' : 'nav-link'} id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false" onClick={() => setIsLogin(2)}>SIGN UP </button>
                                    </li>
                                </ul>
                                {isLogin === 1 ? (
                                <div class="tab-content" id="pills-tabContent">
                                    <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
                                        <div class="modal-body2">
                                            <div class="form_container">
                                                
                                                <div class="input-group mt-5"> <span class="input-group-text">
                                                    <img src={user} alt="" /></span>
                                                    <input type="email" class="form-control " name="email" autocomplete="email" placeholder="Email or Verified Username" onChange={handleChange}/>
                                                </div>
                                                <div class="input-group mt-5"> <span class="input-group-text"><img src={passwordIcon} alt="" /></span>
                                                    <input id="password" type="password" class="form-control" placeholder="Password" name="password" required="" autocomplete="current-password" onChange={handleChange}/>
                                                </div>
                                                
                                                    {isLoading ? (
                                                        <button type="submit" class="btn btn-lg gredient_bg1 btn-block" disabled={true}> 
                                                            <Loader className="login-spinner" />
                                                        </button>
                                                    ) : (
                                                        <>
                                                            <button type="submit" class="btn btn-lg gredient_bg1 btn-block" onClick={handleSubmitClick}>
                                                                <img src={logOut} alt="" onClick={handleSubmitClick} /> LOG IN
                                                            </button>
                                                        </>
                                                    )}
                                                
                                                <div class="text-center forgot_b"> <a class="forgot-link  text-center" href="#">Forgot Password</a> </div>


                                                <div className="secure text-center">
                                                    <img src={secure} alt="" />
                                                </div>

                                                <div class="poweredby text-center">
                                                <p> Powered by E</p>
                                                    <h5> <img src={ebank} alt="" /> </h5>
                                                   
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
                                        <div class="modal-body2">
                                            <div class="form_container">
                                                <input type="hidden" name="_token" value="AW3ouFIpyHOxMr1ERplKl1mPhzJ1eAdroJ7uE9wO" />
                                                <div class="input-group mt-5"> <span class="input-group-text"><img src={user} alt="" /></span>
                                                    <input type="email" class="form-control " name="email" value="" required="" autocomplete="email" autofocus="" placeholder="Email or Verified Username" />
                                                </div>
                                                <div class="input-group mt-5"> <span class="input-group-text"><img src={passwordIcon} alt="" /></span>
                                                    <input id="password" type="password" class="form-control  " placeholder="Password" name="password" required="" autocomplete="current-password" />
                                                </div>
                                                <button type="submit" class="btn btn-lg gredient_bg btn-block"> <img src={logOut} alt="" /> LOG IN </button>
                                                <div class="text-center forgot_b"> <a class="forgot-link  text-center" href="">Forgot Password</a> </div>
                                                <div class="d-flex justify-content-between poweredby">
                                                    <h5> <img src={ebank} alt="" /> </h5>
                                                    <p> Powered by E</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                ):(
                                <div class="tab-content" id="pills-tabContent">
                                    <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
                                        <div class="modal-body2">
                                            <div class="form_container">
                                                
                                                <div class="input-group mt-5"> <span class="input-group-text">
                                                    <img src={user} alt="" /></span>
                                                    <input type="email" class="form-control " name="email" autocomplete="email" placeholder="Email or Verified Username" onChange={handleChange}/>
                                                </div>
                                                <div class="input-group mt-5"> <span class="input-group-text"><img src={passwordIcon} alt="" /></span>
                                                    <input id="password" type="password" class="form-control" placeholder="Password" name="password" required="" autocomplete="current-password" onChange={handleChange}/>
                                                </div>
                                                
                                                {isLoading ? (
                                                    <button type="submit" class="btn btn-lg gredient_bg1 btn-block" disabled={true}> 
                                                        <Loader className="login-spinner" />
                                                    </button>
                                                ) : (
                                                    <>
                                                        <button type="submit" class="btn btn-lg gredient_bg1 btn-block" onClick={handleSubmitClick}>
                                                            <img src={logOut} alt="" onClick={handleSubmitClick} /> LOG IN
                                                        </button>
                                                    </>
                                                )}
                                                
                                                <div class="text-center forgot_b"> <a class="forgot-link  text-center" href="#">Forgot Password</a> </div>

                                                <div className="secure text-center">
                                                    <img src={secure} alt="" />
                                                </div>

                                                <div class="poweredby text-center">
                                                    <p> Powered by E</p>
                                                    <h5> <img src={ebank} alt="" /> </h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">
                                        <div class="modal-body2">
                                            <div class="form_container">
                                                <input type="hidden" name="_token" value="AW3ouFIpyHOxMr1ERplKl1mPhzJ1eAdroJ7uE9wO" />
                                                <div class="input-group mt-5"> <span class="input-group-text"><img src={user} alt="" /></span>
                                                    <input type="email" class="form-control " name="email" value="" required="" autocomplete="email" autofocus="" placeholder="Email or Verified Username" />
                                                </div>
                                                <div class="input-group mt-5"> <span class="input-group-text"><img src={passwordIcon} alt="" /></span>
                                                    <input id="password" type="password" class="form-control  " placeholder="Password" name="password" required="" autocomplete="current-password" />
                                                </div>
                                                <button type="submit" class="btn btn-lg gredient_bg btn-block"> <img src={logOut} alt="" /> LOG IN </button>
                                                <div class="text-center forgot_b"> <a class="forgot-link  text-center" href="">Forgot Password</a> </div>
                                                <div class="d-flex justify-content-between poweredby">
                                                    <h5> <img src={ebank} alt="" /> </h5>
                                                    <p> Powered by E</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                isOpen={notificationModalIsOpen}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeNotificationModal}
                style={customStylesNotification}
                contentLabel="Example Modal"
                bodyOpenClassName="modal-open3"
            >
                <h3 ref={(_subtitle) => (subtitle = _subtitle)}> </h3>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="noti_box">
                                <div className="container">
                                    <div className="row">
                                        <div className="noti_overlay_box">
                                            <div className="ver_head">
                                            <div className="d-flex justify-content-between align-items-center">
                                                
                                                <img src={vchat} alt="" />
                                                <img className="arrow-down" src={arrowdown} alt="" onClick={closeNotificationModal}/>
                                            </div>
                                            </div>
                                            <div className="notificaton_head">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span>NOTIFICATIONS</span>
                                                <p>{notifications.length}</p>
                                            </div>
                                            </div>
                                            <div className="notifiction-box" style={{maxHeight:window.innerHeight - 350}}>
                                            {notifications.map((item) => (
                                                <div className="notify-box">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="img_noti">
                                                        {/* <img src={vchat} alt="" /> */}
                                                        {item.profile_picture ? (
                                                            <img src={ASSETS_URL+"agent/profile/"+item.profile_picture} alt="" />
                                                        )
                                                        :(
                                                            <img className="p-no-image" src={vchat} alt="" />
                                                        )}
                                                        </div>
                                                        <div className="noti_title">
                                                        <h6>{item.description}</h6>
                                                        <p>{item.date}</p>
                                                        </div>
                                                        <div className="ms-auto right_noti_img rightnoti1">
                                                        {item.type === 'agent_register' &&
                                                            <img src={ASSETS_URL+"agent/profile/"+item.event_image} alt="" />
                                                        }
                                                        {item.type === 'add_proeprty' &&
                                                            <img src={ASSETS_URL+"properties/media/small/"+item.event_image} alt="" />
                                                        }
                                                        {item.type === 'add_story' &&
                                                            <img src={ASSETS_URL+"story/media/small/"+item.event_image} alt="" />
                                                        }
                                                        </div>
                                                        {item.type === 'chat_message' &&
                                                            <div className="ms-auto right_noti_img2">
                                                                <img src={comment} alt="" />
                                                            </div>
                                                        }
                                                        
                                                    </div>
                                                </div>
                                            ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                isOpen={chatModalIsOpen}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeChatModal}
                style={customStylesChat}
                contentLabel="Example Modal"
                bodyOpenClassName="modal-open3"
            >
                <h3 ref={(_subtitle) => (subtitle = _subtitle)}> </h3>
                <div className="container">
                    <div className="row">

                        {loading && (
                        <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            // backgroundColor: 'rgb(255, 255, 255)',
                            zIndex: 1,
                        }}
                        >
                        <p>
                            <button type="submit" class="btn btn-lg gredient_bg1 btn-block" disabled={true}> 
                                <Loader className="login-spinner" />
                            </button>
                        </p>
                        </div>
                        )}

                        {isChatVisible === false &&
                            <div className="col-md-12">
                                <div className="noti_box">
                                    <div className="container">
                                        <div className="row">
                                        <div className="noti_overlay_box">
                                            <div className="ver_head">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <img src={vchat} alt="" />
                                                <img className="arrow-down" src={arrowdown} alt="" onClick={closeChatModal}/>
                                            </div>
                                            </div>
                                            <div className="notificaton_head">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span>MESSAGES</span>
                                                <p>{chatHistory.length}</p>
                                            </div>
                                            </div>
                                            <div className="chat-list" style={{maxHeight:window.innerHeight - 320}}>
                                            {chatHistory.map((item) => (
                                            <Link className="over_link_noti" to="#" onClick={() => getChatDetails(item.last_message.user_id,item.last_message.user_name,item.last_message.profile_picture)}>
                                            <div className="notify-box">
                                                <div className="d-flex justify-content-between">
                                                <div className="img_noti">
                                                    {/* <img src={vchat} alt="" /> */}
                                                    {item.last_message.profile_picture ? (
                                                        <img src={ASSETS_URL+"agent/profile/"+item.last_message.profile_picture} alt="" />
                                                    )
                                                    :(
                                                        <img className="p-no-image" src={vchat} alt="" />
                                                    )}
                                                </div>
                                                <div className="noti_title">
                                                    <h6>{item.last_message.user_name}</h6>
                                                    <p>{replaceUnicodeWithEmoji(item.last_message.message)}</p>
                                                </div>
                                                <div className="msg-rt ms-auto">
                                                    {item.last_message.date}
                                                </div>
                                                </div>
                                            </div>
                                            </Link>
                                            ))}
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {isChatVisible &&
                            <div className="col-md-12">
                                <div className="chat_box">
                                    <div className="container">
                                        <div className="row">
                                        <div className="chat_overlay_box">
                                            <div className="chat-new-bo">
                                                <div className="ver_head">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="arrow_long">
                                                            <img src={longarrow} alt="" className="arrow-down" onClick={backToChatButton}/>
                                                        </div>
                                                        <div class="img_chat_pro">
                                                            {chatUserProfilePicture ? (
                                                                <img src={chatUserProfilePicture} alt="" />
                                                            )
                                                            :(
                                                                <img className="p-no-image" src={vchat} alt="" />
                                                            )}
                                                        </div>
                                                        <div class="chat_title">
                                                        <h3>
                                                            {chatUserName}
                                                        </h3>
                                                        </div>
                                                        <div class="ms-auto dottedvr">
                                                        
                                                        <img src={dottedvr} alt="" />
                                                        </div>
                                                        {/* <img src={arrowdown} alt="" /> */}
                                                        <img src={arrowdown} alt="" className="arrow-down" onClick={closeChatModal}/>
                                                    </div>
                                                </div>

                                                <div className="chat-list2" style={{maxHeight:window.innerHeight - 320}}>
                                                    {chatDetails.map((item) => (
                                                    item.property === null && (
                                                        loggedInUserId !== item.sender_id ? (
                                                        <div className="chat_box_side float-start">
                                                            <div className="chat_bg_light">
                                                            <p>{replaceUnicodeWithEmoji(item.message)}</p>
                                                            </div>
                                                            <div className="chattime">
                                                            <p>{item.date}</p>
                                                            </div>
                                                        </div>
                                                        )
                                                        :
                                                        (
                                                        <>
                                                        <div className="chat_box_side2 float-end">
                                                            <div className="chat_bg_light2" style={{ textAlign:"right" }}>
                                                            <p>{replaceUnicodeWithEmoji(item.message)}</p>
                                                            </div>
                                                            <div className="chattime2">
                                                            <p>{item.date}</p>
                                                            </div>
                                                        </div>
                                                        
                                                        </>
                                                        )
                                                    )
                                                    ))}
                                                </div>
                                            </div>


                                            <div className="bottom_chat_frame" ref={boxRef}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <input type="text" 
                                                    onChange={(e) => setInputText(e.target.value)}
                                                    onKeyDown={(e) => {
                                                    if (e.key === "Enter")
                                                        handlerChatFuntion(chatUserId);
                                                    }} value={inputText}/>
                                                    <Link to="#" onClick={() => handlerChatFuntion(chatUserId)}><img src={enter} style={{ width:'25px' }}/></Link>
                                                    <span className="camera"><img src={camera} alt="" /></span>
                                                    <span className="voice"><img src={voice} alt="" /></span>
                                                    <span className="dollor"><img src={dollor} alt="" /></span>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </Modal>

            <section class="top_section">
                <div class="head_part">
                    <div class="container">
                        <div class="d-flex justify-content-between align-items-center flex-wrap">
                            <div class="logo">
                                <Link to="/">
                                <img src={verifiedPropertyLogo} alt="verified-properties-logo"/>
                                </Link>
                            </div>
                            {/* <div class="searchbox d-flex">
                                <input type="text" class="form-control" placeholder="Search" />
                                <button type="button"><img src={searchIcon} alt="search-icon" /></button>
                            </div> */}
                            
                            <div class="login_box d-flex align-items-center">
                                <div class="top_links">
                                    <ul>
                                        <li>
                                            <a to="#" target="_blank" class="text-lik active" style={{ color:'#ff00d8' }}>Website</a>
                                        </li>
                                        <li>
                                            <a href="https://verified.properties/" class="text-lik">Dashboard</a>
                                        </li>
                                        <li>
                                            {(!token || token  === 'undefined') ?
                                                <a class="text-lik" href="#!"onClick={firstLogin}><img className="bell_icon" src={bell} alt="bell"/></a>
                                            :
                                                <a class="text-lik" href="#!" onClick={openNotificationModal}><img className="bell_icon" src={bell} alt="bell"/></a>
                                            }
                                        </li>

                                         <li>
                                            {(!token || token  === 'undefined') ?
                                                <Link href="#" onClick={firstLogin} class="text-lik"><img className="bell_icon" src={comment} alt="bell"/></Link>
                                            :
                                                <Link href="#" onClick={openChatModal} class="text-lik"><img className="bell_icon" src={comment} alt="bell"/></Link>
                                            }
                                        </li>
                                    </ul>
                                </div>
                                {(!token || token  === 'undefined') ?
                                    <span onClick={openLogInModal}>Log In</span>
                                :
                                    <span onClick={() => logout()}>Logout</span>
                                }
                                {/* <span>Log In</span> */}
                                <img className="profile_img_top" src={profileImg} alt="profile-img"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
                
            {!pathname.startsWith("/property/") && !pathname.startsWith("/property-new")   &&                     
            <section class="stories">
                <div class="container">
                    <div class="justify-content-between align-items-center">
                        <div class="story_box">
                                <Swiper
                                direction={'horizontal'}
                                slidesPerView={15}
                                spaceBetween={15}
                                mousewheel={true}
                                modules={[Mousewheel]}
                                className="mySwiper"
                                loop={false}
                                speed={100}
                                cssMode={window.safari !== undefined}
                                edgeSwipeDetection={true}

                                // breakpoints={{
                                //     320: {
                                //         slidesPerView: 5,
                                //         spaceBetween:15
                                //     },
                                //     579: {
                                //         slidesPerView: 5,
                                //         spaceBetween:0
                                //     },
                                //     768: {
                                //         slidesPerView:7,
                                //         spaceBetween:15
                                //     },
                                //     1024: {
                                //         slidesPerView: 12,
                                //         spaceBetween:15
                                //     },
                                //      1300: {
                                //         slidesPerView: 14,
                                //         spaceBetween:15
                                //     },
                                //      1600: {
                                //         slidesPerView: 15,
                                //         spaceBetween:15
                                //     },
                                //       1728: {
                                //         slidesPerView: 16,
                                //         spaceBetween:15
                                //     },
                                //      1800: {
                                //         slidesPerView: 18,
                                //     },
                                // }}
                                >
                                    <ul>
                                    {story.map((element, index) => (
                                        element.latest_story.status === 1 &&
                                        <SwiperSlide>
                                            <li>
                                                <div style={{display:'flex', alignItems:'center',minHeight:'106px',textAlign:'center'}}>
                                                <div style={{display:'inline-block'}}>
                                                <a key={index} href="#" className={`story-size-${element.latest_story.shape} ${activeIndex === index ? 'active-story' : ''}`}>
                                                <img onClick={() => openModal(element.latest_story.user_id,index,element.profile_picture,)} src={ASSETS_URL + "story/media/small/" + element.latest_story.image} alt="" style={{width:'100%',height:'100%'}}/>
                                                </a>
                                                </div>
                                                </div>
                                                <span>{element.user_name}</span>
                                            </li>
                                            {/* <li><a href="#"><img onClick={() => openModal(element.latest_story.user_id)} src={ASSETS_URL+"story/media/small/"+element.latest_story.image} alt="" className={ "story-size-" +element.latest_story.shape }/></a><span>{element.user_name}</span></li> */}
                                        </SwiperSlide>
                                    ))}
                                    </ul>
                                </Swiper>
                        </div>
                    </div>
                </div>
            </section>
            }

            <section class="filter_box ">
                <div class="container">
                    <div class="filter_links">
                        <Swiper
                        direction={'horizontal'}
                        slidesPerView={15}
                        spaceBetween={0}
                        mousewheel={true}
                        modules={[Mousewheel]}
                        className="mySwiper"
                        loop={true}
                        speed={100}
                        >
                            <ul>
                                <SwiperSlide><li><Link to="/" className={pathname === '/' ? 'text-all active' : 'text-all'}>ALL</Link></li></SwiperSlide>
                                <SwiperSlide><li><Link to="/buy-properties" class={pathname === '/buy-properties' ? 'text-buy active' : 'text-buy'}>BUY</Link></li></SwiperSlide>
                                <SwiperSlide><li><Link to="/rent-properties" class={pathname === '/rent-properties' ? 'text-rent active' : 'text-rent'}>RENT</Link></li></SwiperSlide>
                                <SwiperSlide><li><Link to="/developers" className={pathname === '/developers' ? 'text-developers active' : 'text-developers'}>DEVELOPERS</Link></li></SwiperSlide>
                                <SwiperSlide><li><Link to="/projects" class={pathname === '/projects' ? 'text-projects active' : 'text-projects'}>PROJECTS</Link></li></SwiperSlide>
                                <SwiperSlide><li><Link to="/new-properties" class={pathname === '/new-properties' ? 'text-new active' : 'text-new'}>NEW</Link></li></SwiperSlide>
                                <SwiperSlide><li><Link to="/trending-properties" class={pathname === '/trending-properties' ? 'text-trending active' : 'text-trending'}>TRENDING</Link></li></SwiperSlide>
                                <SwiperSlide><li><Link to="/pre-launch" class={pathname === '/pre-launch' ? 'text-pre-launch active' : 'text-pre-launch'}>PRE-LAUNCH</Link></li></SwiperSlide>
                                <SwiperSlide><li><Link to="/brokerage" class={pathname === '/brokerage' ? 'text-brokerage active' : 'text-brokerage'}>BROKERAGES</Link></li></SwiperSlide>
                                <SwiperSlide><li><Link to="/brokers" class={pathname === '/brokers' ? 'text-brokers active' : 'text-brokers'}>BROKERS</Link></li></SwiperSlide>
                                <SwiperSlide><li><Link to="/agents" class={pathname === '/agents' ? 'text-agents active' : 'text-agents'}>AGENTS</Link></li></SwiperSlide>
                                <SwiperSlide><li><Link to="/business" class={pathname === '/business' ? 'text-business active' : 'text-business'}>BUSINESS</Link></li></SwiperSlide>
                                <SwiperSlide><li><Link to="/saved-properties" class={pathname === '/saved-properties' ? 'text-saved active' : 'text-saved'}>SAVED</Link></li></SwiperSlide>
                                <SwiperSlide><li><Link to="/like-properties" class={pathname === '/like-properties' ? 'text-likes active' : 'text-likes'}>LIKES</Link></li></SwiperSlide>    
                                <SwiperSlide><li><Link to="#" class={isActive === 16 ? 'text-help active' : 'text-help'}>HELP</Link></li></SwiperSlide>
                                <SwiperSlide><li><Link to="#" class={isActive === 10 ? 'text-broker-preview active' : 'text-broker-preview'}>BROKER PREVIEW</Link></li></SwiperSlide>
                            </ul>
                        </Swiper>
                    </div>
                </div>
            </section>

            {/* <Loading show={loading}/> */}
        </>
    );
};

export default Header;